/**
 * Oceread 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const ocereadPaymentConfig: BrandPaymentConfig = {
  brand: 'oceread',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/oceread/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/oceread/vip_bg.webp',
      memberSubscribeBg: '/images/oceread/member_subscribe_bg.webp',
      vipIcon: '/images/oceread/vip_icon2.png',
      vipDiscountIcon: '/images/oceread/vip_discount.png',
      discountBg: '/images/oceread/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #6B92FD, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF873F',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#EDF2FF',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #A3BBFF 0%, #C6D1ED 70%, #F3F5FA 100%)',
      pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      memberSubscribeBg: '/images/oceread/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
